import { render, staticRenderFns } from "./DataTableV2PaginatedMobile.html?vue&type=template&id=e50181ae&scoped=true&external"
import script from "./DataTableV2PaginatedMobile.js?vue&type=script&lang=js&external"
export * from "./DataTableV2PaginatedMobile.js?vue&type=script&lang=js&external"
import style0 from "./DataTableV2PaginatedMobile.vue?vue&type=style&index=0&id=e50181ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e50181ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import VBtn from '@/agilis/wrappers/VBtn/VBtn.vue'
import VCard from '@/agilis/wrappers/VCard/VCard.vue'
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VProgressCircular,VRow,VSpacer})
